import { render, staticRenderFns } from "./UsersTable.container.vue?vue&type=template&id=064b2ed9&scoped=true&"
import script from "./UsersTable.container.vue?vue&type=script&lang=js&"
export * from "./UsersTable.container.vue?vue&type=script&lang=js&"
import style0 from "./UsersTable.container.vue?vue&type=style&index=0&id=064b2ed9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b2ed9",
  null
  
)

export default component.exports